const RadarAnimation = () => {
  return (
    <div className="relative w-80 h-80">
      {/* Outer rings */}
      <div className="absolute inset-0 rounded-full border border-brand-violet/20" />
      <div className="absolute inset-4 rounded-full border border-brand-violet/15" />
      <div className="absolute inset-8 rounded-full border border-brand-violet/10" />
      <div className="absolute inset-12 rounded-full border border-brand-blue/10" />

      {/* Sweep line — CSS animation */}
      <div className="absolute inset-0 radar-sweep">
        <div
          className="absolute top-1/2 left-1/2 w-1/2 h-0.5 origin-left"
          style={{
            background: "linear-gradient(90deg, hsl(274 64% 46%), transparent)",
          }}
        />
      </div>

      {/* Sweep trail — CSS animation */}
      <div
        className="absolute inset-0 rounded-full radar-sweep"
        style={{
          background: "conic-gradient(from 0deg, transparent 0deg, hsl(274 64% 46% / 0.15) 0deg, transparent 60deg)",
        }}
      />

      {/* Blips — CSS animations */}
      {[
        { top: "20%", left: "60%", delay: "0s" },
        { top: "45%", left: "75%", delay: "1.2s" },
        { top: "70%", left: "40%", delay: "2.4s" },
        { top: "30%", left: "30%", delay: "0.8s" },
        { top: "55%", left: "25%", delay: "1.8s" },
        { top: "35%", left: "65%", delay: "0.4s" },
      ].map((blip, i) => (
        <div
          key={i}
          className="absolute w-2.5 h-2.5 rounded-full bg-primary animate-[blipPulse_2s_ease-in-out_infinite]"
          style={{ top: blip.top, left: blip.left, animationDelay: blip.delay }}
        />
      ))}

      {/* Center dot */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-3 h-3 rounded-full bg-brand-violet shadow-lg brand-glow" />
      </div>
    </div>
  );
};

export default RadarAnimation;